import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../common/rest.operators';
import { PayloadAction } from '../../store.model';

import { ActionType } from './power-bi.action';
import { getModuleInjector } from './power-bi.metadata';
import { PowerBiService } from './power-bi.service';
import { Reload, ReloadResult, reloadResult } from './state/reload.action';

const reload = (
    action: Observable<PayloadAction<ActionType, Reload>>,
): Observable<PayloadAction<ActionType, ReloadResult>> =>
    action.pipe(
        ofType(ActionType.POWER_BI__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const service =
                getModuleInjector().get<PowerBiService>(PowerBiService);
            return service.listReports([act.payload.reportTypeId]).pipe(
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            powerBiReports: ret,
                        },
                        act.storePath,
                    );
                }),
                catchErrorLogRet(
                    of(reloadResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );

export const powerBiEpics = [reload];
